import { BadgerAuthScreen } from "@/components/auth/BadgerAuthScreen";

interface AuthStatusProps {
  type: "loading" | "redirecting" | "error";
  error?: string | null;
  message?: string;
  redirectAttempts?: number;
  maxRedirectAttempts?: number;
  accounts?: unknown[];
  instance?: { getActiveAccount?: () => unknown };
}

export const AuthStatus = ({
  type,
  error,
  message,
  redirectAttempts,
  maxRedirectAttempts,
  accounts,
  instance,
}: AuthStatusProps) => {
  if (type === "error") {
    const debugLines: string[] = [];
    if (redirectAttempts !== undefined) {
      debugLines.push(`Redirect attempts: ${redirectAttempts}`);
    }
    if (maxRedirectAttempts !== undefined) {
      debugLines.push(`Max redirect attempts: ${maxRedirectAttempts}`);
    }
    debugLines.push(`Current URL: ${window.location.href}`);
    debugLines.push(`Accounts found: ${accounts?.length ?? 0}`);
    debugLines.push(
      `Active account: ${instance?.getActiveAccount?.() ? "Yes" : "No"}`,
    );

    return (
      <BadgerAuthScreen
        variant="error"
        title="Configuration error"
        message={
          message ??
          "Please check your environment variables and try again."
        }
        error={error ?? undefined}
        debugLines={debugLines}
      />
    );
  }

  if (type === "redirecting") {
    const detail =
      redirectAttempts !== undefined && maxRedirectAttempts !== undefined
        ? `Attempt ${redirectAttempts} of ${maxRedirectAttempts}`
        : undefined;

    return (
      <BadgerAuthScreen
        variant="redirecting"
        message={message ?? "Please wait while we open Microsoft sign-in."}
        detail={detail}
      />
    );
  }

  return (
    <BadgerAuthScreen
      variant="loading"
      message={message ?? "Checking authentication…"}
    />
  );
};
